import { apiRequest } from '@/shared/api/client';
import type { LoginResponse } from '@/shared/api/types';

interface LoginInput {
  username: string;
  password: string;
}

/** Admin login. Backend sets the HttpOnly refresh-token cookie on
    success; the body's `refresh_token` is intentionally ignored. */
export async function adminLogin(input: LoginInput): Promise<LoginResponse> {
  return apiRequest<LoginResponse>('/v1/auth/admin/login', {
    method: 'POST',
    json: {
      username: input.username,
      password: input.password,
    },
  });
}

/** Client-cabinet login (provider accounts). Same HttpOnly-cookie
    mechanism as admin. The login form falls back to this when
    the admin endpoint rejects the credentials, so both roles share one
    screen. */
export async function clientLogin(input: {
  username: string;
  password: string;
}): Promise<LoginResponse> {
  return apiRequest<LoginResponse>('/v1/auth/client/login', {
    method: 'POST',
    json: { username: input.username, password: input.password },
  });
}
